<template>
  <h3
    :class="
      `
        mb-5
        d-flex
        text-subtitle-1
        grey--text
        center-items
        text--darken-2
        font-weight-regular
        board__column-title${clean ? '--clean' : ''}
      `
    "
  >
    <span :class="`board__column-title-line ${color(title)}`" />
    {{ $t(`status.${title}`) }}
    <v-tooltip v-if="information" top>
      <template v-slot:activator="{ on, attrs }">
        <v-icon v-bind="attrs" v-on="on" color="grey lighten-1" small right>
          mdi-information-outline
        </v-icon>
      </template>
      <div class="mw-200 caption text-left">
        {{ information }}
      </div>
    </v-tooltip>

    <v-chip v-if="!clean" class="ml-auto" color="grey lighten-2" small>
      <span class="grey--text text--darken-2 font-weight-bold">
        {{ total }}
      </span>
    </v-chip>

    <v-btn
      @click="setBoardPendingActions(false)"
      class="ml-auto"
      v-else
      small
      icon
    >
      <v-icon small> mdi-close </v-icon>
    </v-btn>
  </h3>
</template>

<script>
import { mapMutations } from 'vuex'

import { handleColors } from '@/util/colors'

export default {
  name: 'BoardColumnTitle',

  props: {
    title: {
      type: String,
      required: true,
    },

    total: {
      type: String | Number,
    },

    clean: {
      type: Boolean,
      default: false,
    },

    information: {
      type: String,
      default: '',
    },
  },

  data() {
    return {
      color: handleColors,
    }
  },

  methods: {
    ...mapMutations(['setBoardPendingActions']),
  },
}
</script>
